<template>
    <div class="task-time">
        <div class="d-flex justify-space-between align-center mb-2">
            <div
                    v-if="!$vuetify.breakpoint.smAndDown"
                    class="color-block__label"
            >{{ $t('msg.list') }}</div>
            <filters
                v-model="filters"
                class="mr-2"
                name="note_list"
                @clear="clearFilters"
            >
                <v-select
                    v-model="filters.is_done"
                    :label="$t('msg.status')"
                    class="card__action"
                    :items="$store.state.dict.statuses"
                    item-value="value"
                    item-text="text"
                    clearable
                    dense
                    outlined
                    hide-details
                ></v-select>
            </filters>
        </div>
        <draggable
            v-model="items"
            class="lists__items"
            @change="changeSequence($event)"
            @start="startSequence()"
            handle=".drag"
            :disabled="dragDisabled"
        >
            <item
                    v-for="(item, key) in getItems"
                    :key="item._key"
                    :index="key"
                    :item="item"
                    :note-id="noteId"
                    @removed="removed($event)"
                    @add-next="add()"
                    :drag-disabled="dragDisabled"
            ></item>
        </draggable>
        <div>
            <div
                    class="mt-2 task_type__btn-add"
                    :class="{
                      'task_type__btn-add_disabled': disabledBtnAdd
                    }"
                    @click="add()"
                    style="cursor: pointer"
            >+ {{ $t('msg.addLine') }}</div>
        </div>
    </div>
</template>

<script>
    import Item from './Item';
    import Draggable from 'vuedraggable';
    import Filters from '@/components/ui/Filters';

    export default {
        components: {Item, Draggable, Filters},
        props: {
            noteId: {type: Number, default: null}
        },
        data() {
            return {
                items: [],
                loading: [],
                changeSeq: {
                    prev_id: 0,
                    next_id: 0
                },
                changeSeqId: 0,
                drag: null,
                filters: {
                    is_done: null
                },
                sequenceModels: [],
                lastKey: 1,
            }
        },
        computed: {
            getItems() {
                return this.items.filter(model => {
                    let isDone = () => {
                        if (typeof this.filters.is_done !== 'boolean') return true;
                        return this.filters.is_done === model.is_done;
                    }

                    return isDone();
                });
            },
            dragDisabled() {
                return !(this.items.find(v => v.id === null) === undefined);
            },
            disabledBtnAdd() {

              for (let key in this.items) {
                if (this.items[key].id === null) {
                  return true;
                }
              }

              return false;
            }
        },
        methods: {
            clearFilters() {
                this.filters.is_done = null;
            },
            loadList() {
                if (this.noteId === null) return;
                this.loading = true;
                this.$store.dispatch('loadList', {id: this.noteId})
                    .then(res => {

                      for (let key in res) {
                        res[key]['_key'] = this.lastKey;
                        this.lastKey++;
                      }

                      this.items = res;
                      this.sequenceModels = res;
                    })
                    .finally(() => this.loading = false);
            },
            add() {
              if (this.disabledBtnAdd) {
                return;
              }

              this.items.push({
                id: null,
                name: null,
                sequence: null,
                _key: this.lastKey,
              });

              this.lastKey++;
            },
            removed(index) {
                this.items.splice(index, 1);
            },
            changeSequence(event) {

              let res = this.recountSequenceModels(this.items, this.sequenceModels, event);

              this.sequenceModels = res.models;

                this.$store.dispatch('changeListSequence', {
                    id: this.noteId,
                    subId: res.id,
                    data: {
                      from_seq: res.from,
                      to_seq: res.to,
                    },
                });
            },
            startSequence() {
              this.sequenceModels = this.items;
            },
        },
        created() {
            this.loadList();
        }
    }
</script>

<style lang="scss">
    .task-time {
      .task_type__btn-add {
        &.task_type__btn-add_disabled {
          color: rgba(148, 148, 148, 0.55);
          user-select: none;
          cursor: default !important;
        }
      }
    }
</style>